export default "__VITE_ASSET__CEi51d96__"